import { render, staticRenderFns } from "./ManageLiveSourceModal.vue?vue&type=template&id=385d9b6b&scoped=true&"
import script from "./ManageLiveSourceModal.vue?vue&type=script&lang=js&"
export * from "./ManageLiveSourceModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageLiveSourceModal.vue?vue&type=style&index=0&id=385d9b6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d9b6b",
  null
  
)

export default component.exports